// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-card {
  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;
  padding: 15px;
  border-radius: 20px;
  margin: 20px;
}
.request-card .right-side {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 20px;
  direction: rtl;
  text-align: right;
}
.request-card .right-side div {
  display: inline-flex;
}
.request-card .right-side div * {
  margin-right: 5px;
}
.request-card .left-side {
  flex: 1 1 100%;
  box-sizing: border-box;
  max-width: 25%;
  justify-content: center;
  display: flex;
  border-right: 4px dashed #eee;
}
.request-card .left-side div {
  display: inline-flex;
}
.request-card .left-side div * {
  margin-right: 5px;
}

.item {
  padding: 0 10px;
  margin-top: 17px;
  min-width: 230px;
  align-items: center;
  justify-content: center;
}

p {
  margin-top: 10px;
}

.text-item {
  font-size: 13px;
}

.btn {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 105px;
  border: 2px solid #eee;
  background-color: rgba(0, 0, 255, 0.7803921569);
  color: white;
}

.icon-card {
  margin: auto;
  margin-top: 1px;
  margin-left: 8px;
  font-size: 20px;
}

.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

mat-icon {
  font-size: 26px;
  margin-left: 10px;
}

h1 {
  font-size: 1.5rem;
}

mat-paginator {
  direction: ltr;
}

::ng-deep .mat-paginator-container {
  margin: auto !important;
  display: flex !important;
  justify-content: center !important;
}

.text-title {
  text-align: center;
}

.item-inline {
  padding: 0 10px;
  margin-top: 17px;
  min-width: 230px;
  align-items: center;
  justify-content: center;
  color: blue;
}

.item-outline {
  padding: 0 10px;
  margin-top: 17px;
  min-width: 230px;
  align-items: center;
  justify-content: center;
  color: red;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/verification-marketer/verification-marketer.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/verification-marketer/verification-marketer.component.scss"],"names":[],"mappings":"AAEE;EACE,uGAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;ACDJ;ADEI;EAOE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;ACNN;ADNM;EACE,oBAAA;ACQR;ADPQ;EACE,iBAAA;ACSV;ADGI;EACE,cAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,6BAAA;ACDN;ADEM;EACE,oBAAA;ACAR;ADCQ;EACE,iBAAA;ACCV;;ADIE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ACDJ;;ADIE;EACE,gBAAA;ACDJ;;ADGE;EACE,eAAA;ACAJ;;ADIE;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,+CAAA;EACA,YAAA;ACDJ;;ADGC;EACC,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACAF;;ADGA;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACAF;;ADEA;EACE,eAAA;EACE,iBAAA;ACCJ;;ADCA;EACE,iBAAA;ACEF;;ADAA;EACE,cAAA;ACGF;;ADAA;EACE,uBAAA;EACA,wBAAA;EACA,kCAAA;ACGF;;ADDA;EACE,kBAAA;ACIF;;ADFA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;ACKF;;ADHA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;ACMF;;ADJA;EACE,aAAA;EACA,YAAA;EACA,aAAA;ACOF","sourcesContent":["\r\n  \r\n  .request-card {\r\n    box-shadow: rgb(103 103 103 / 35%) -4px 0px 20px 2px, rgb(255 255 255 / 40%) -20px -1px 60px -30px;\r\n    padding: 15px;\r\n    border-radius: 20px;\r\n    margin: 20px;\r\n    .right-side {\r\n      div {\r\n        display: inline-flex;\r\n        * {\r\n          margin-right: 5px;\r\n        }\r\n      }\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex-wrap: wrap;\r\n      justify-content: space-between;\r\n      padding-left: 20px;\r\n      direction: rtl;\r\n      text-align: right;\r\n  \r\n    }\r\n    .left-side {\r\n      flex: 1 1 100%;\r\n      box-sizing: border-box;\r\n      max-width: 25%;\r\n      justify-content: center;\r\n      display: flex;\r\n      border-right: 4px dashed #eee;\r\n      div {\r\n        display: inline-flex;\r\n        * {\r\n          margin-right: 5px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .item {\r\n    padding: 0 10px;\r\n    margin-top: 17px;\r\n    min-width: 230px;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  p{\r\n    margin-top: 10px;\r\n  }\r\n  .text-item{\r\n    font-size: 13px;\r\n}\r\n  \r\n\r\n  .btn{\r\n    border-radius: 15px;\r\n    height: 45px;\r\n    font-size: 12px;\r\n    width: 105px;\r\n    border: 2px solid #eee;\r\n    background-color: #0000ffc7;\r\n    color: white;\r\n  }\r\n .icon-card{\r\n  margin: auto;\r\n  margin-top: 1px;\r\n  margin-left: 8px;\r\n  font-size: 20px;\r\n}\r\n \r\n.title{\r\n  margin-bottom: 10px;\r\n  margin-top: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\nmat-icon{\r\n  font-size: 26px; \r\n    margin-left: 10px;\r\n}\r\nh1{\r\n  font-size: 1.5rem;\r\n}\r\nmat-paginator{\r\n  direction: ltr;\r\n}\r\n\r\n::ng-deep .mat-paginator-container {\r\n  margin: auto !important;\r\n  display: flex !important;\r\n  justify-content: center !important;\r\n}\r\n.text-title{\r\n  text-align: center;\r\n}\r\n.item-inline{\r\n  padding: 0 10px;\r\n  margin-top: 17px;\r\n  min-width: 230px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: blue;\r\n}\r\n.item-outline{\r\n  padding: 0 10px;\r\n  margin-top: 17px;\r\n  min-width: 230px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: red;\r\n}\r\n.parent-both{\r\n  display: flex;\r\n  margin: auto;\r\n  padding: 20px;\r\n}",".request-card {\n  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;\n  padding: 15px;\n  border-radius: 20px;\n  margin: 20px;\n}\n.request-card .right-side {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-left: 20px;\n  direction: rtl;\n  text-align: right;\n}\n.request-card .right-side div {\n  display: inline-flex;\n}\n.request-card .right-side div * {\n  margin-right: 5px;\n}\n.request-card .left-side {\n  flex: 1 1 100%;\n  box-sizing: border-box;\n  max-width: 25%;\n  justify-content: center;\n  display: flex;\n  border-right: 4px dashed #eee;\n}\n.request-card .left-side div {\n  display: inline-flex;\n}\n.request-card .left-side div * {\n  margin-right: 5px;\n}\n\n.item {\n  padding: 0 10px;\n  margin-top: 17px;\n  min-width: 230px;\n  align-items: center;\n  justify-content: center;\n}\n\np {\n  margin-top: 10px;\n}\n\n.text-item {\n  font-size: 13px;\n}\n\n.btn {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 105px;\n  border: 2px solid #eee;\n  background-color: rgba(0, 0, 255, 0.7803921569);\n  color: white;\n}\n\n.icon-card {\n  margin: auto;\n  margin-top: 1px;\n  margin-left: 8px;\n  font-size: 20px;\n}\n\n.title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nmat-icon {\n  font-size: 26px;\n  margin-left: 10px;\n}\n\nh1 {\n  font-size: 1.5rem;\n}\n\nmat-paginator {\n  direction: ltr;\n}\n\n::ng-deep .mat-paginator-container {\n  margin: auto !important;\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.text-title {\n  text-align: center;\n}\n\n.item-inline {\n  padding: 0 10px;\n  margin-top: 17px;\n  min-width: 230px;\n  align-items: center;\n  justify-content: center;\n  color: blue;\n}\n\n.item-outline {\n  padding: 0 10px;\n  margin-top: 17px;\n  min-width: 230px;\n  align-items: center;\n  justify-content: center;\n  color: red;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
